/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type ClaimViews = typeof ClaimViews[keyof typeof ClaimViews];


export const ClaimViews = {
  All: 'All',
  Primary: 'Primary',
  Secondary: 'Secondary',
} as const;
